import { createFileRoute } from "@tanstack/react-router";
import AdminDebugResend from "@/pages/AdminDebugResend";

export const Route = createFileRoute("/admin/debug-resend/")({
  component: AdminDebugResend,
});
